module.exports = __webpack_public_path__ + "static/media/T09 - Manzoni.33adc1a7.jpg";